const catalog = {
  moduleTitle: "Modules",
  actions: {
    update: "Edit selling price",
  },
  permissions: {
    core: "Core",
    moduleManagement: "Module Management",
    modules: "Modules",
  },
  listTitle: "Modules",
  listSubtitle: "Review sellable modules and manage their selling price",
  filters: {
    search: "Search modules",
    searchPlaceholder: "Search by name",
  },
  table: {
    module: "Module",
    purchasingPrice: "Purchasing price",
    sellingPrice: "Selling price",
    actions: "Actions",
    empty: "No modules match these filters.",
    error: "Modules could not be loaded.",
    loading: "Loading modules",
    showingCount: "Showing {{count}} of {{total}}",
    rowsPerPageLabel: "Rows per page",
    nextPage: "Next page",
    previousPage: "Previous page",
    pagination: "Pagination",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
  },
  actionMenu: {
    trigger: "Module actions",
  },
  editDialog: {
    title: "Edit selling price",
    description: "Update the selling price for {{name}}.",
    moduleName: "Module",
    purchasingPrice: "Purchasing price",
    purchasingPriceHint: "Fixed by the catalogue; not editable here.",
    sellingPrice: "Selling price",
    save: "Save changes",
    cancel: "Cancel",
    close: "Close edit selling price dialog",
  },
  validation: {
    sellingPriceRequired: "Selling price is required.",
    sellingPriceInvalid: "Enter a valid, non-negative selling price.",
  },
};

export default catalog;
